import { EVENTOS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    informacion: null
};

export default function eventosReducer(state = initialState, action) {
    switch (action.type) {
        case EVENTOS.BUSCAR:
            return { ...state, listado: action.payload };

        case EVENTOS.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case EVENTOS.EDITAR:
            return {
                ...state,
                listado: state.listado.map(evento =>
                    evento._id === action.payload._id ? action.payload : evento
                )
            };

        case EVENTOS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(evento => evento._id !== action.payload)
            };

        case EVENTOS.DETALLES:
            return { ...state, detalles: action.payload };

        case EVENTOS.INFORMACION:
            return { ...state, informacion: action.payload };

        case EVENTOS.LIMPIAR:
            return { ...state, detalles: null, informacion: null };

        default:
            return state;
    }
}
